import {
  DEFAULT_AGE_QUOTA_CRITERIA,
  QUALIFICATION_CODE,
  SurveyQualification,
  toConditionNamePairs,
} from '@ps/survey-utils';

import { FeasibilityCriteriaMapperBase } from '../../../utils/feasibility-criteria-mapper.base';
import { FeasibilityDefaultQuotaCriteriaDto } from '../dtos/feasibility.dto';

export class FeasibilityDefaultQuotaCriteriaPayloadMapper extends FeasibilityCriteriaMapperBase<FeasibilityDefaultQuotaCriteriaDto> {
  protected override toCriterion(
    qualification: SurveyQualification,
  ): FeasibilityDefaultQuotaCriteriaDto {
    if (qualification.isRangeType) {
      return {
        qualification_code: qualification.qualificationCode,
        qualification_name: qualification.qualificationName,
        range_sets: qualification.rangeSets,
      };
    }

    // ZIPCODE uploads run to tens of thousands of entries, and this quota is
    // display-only, so neither the codes nor their names are sent.
    const isZipcode =
      qualification.qualificationCode === QUALIFICATION_CODE.ZIPCODE;

    return {
      qualification_code: qualification.qualificationCode,
      qualification_name: qualification.qualificationName,
      condition_codes: isZipcode ? [] : qualification.conditionCodes,
      // No re-filter: `data` already holds exactly the selected conditions.
      condition_names: isZipcode
        ? []
        : toConditionNamePairs(qualification.data),
    };
  }

  protected override defaultAgeCriterion(): FeasibilityDefaultQuotaCriteriaDto {
    return {
      qualification_code: QUALIFICATION_CODE.AGE,
      qualification_name: DEFAULT_AGE_QUOTA_CRITERIA.NAME,
      range_sets: [
        {
          from: DEFAULT_AGE_QUOTA_CRITERIA.MIN,
          to: DEFAULT_AGE_QUOTA_CRITERIA.MAX,
          units: DEFAULT_AGE_QUOTA_CRITERIA.UNITS,
        },
      ],
    };
  }
}
